import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import './CampAdditionalInfo.css';

interface CampAdditionalInfoProps {
  additionalInfo: string;
  className?: string;
}

const CampAdditionalInfo: React.FC<CampAdditionalInfoProps> = ({ additionalInfo, className = '' }) => {
  return (
    <div className={`camp-additional-info-section ${className}`}>
      <h2 className="camp-additional-info-title">Additional Camp Details & Costs</h2>
      <div className="camp-additional-info-content">
        <ReactMarkdown rehypePlugins={[rehypeSanitize]}>
          {additionalInfo}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default CampAdditionalInfo;
